import type { FaireProductEntity } from "../../entity_types/product";

export const p_u5g3vuhaqy: FaireProductEntity = {
  token: "p_u5g3vuhaqy",
  type: "product",
  name: "Cheese Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/09bf5dfd6e7d3200edc5e452907f478d9476b9406495d4311a4710e3e3ba93d1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e844f24bbb486f6970b103daa05b184cee49617c6810cf82a95164e20538dcc9.jpeg",
    "https://cdn.faire.com/fastly/5a4dcdf80054793784652c2bfd64e2fdedcefa104041e7dd189a0796b4e49dfe.jpeg",
  ],
  priceDollars: 8,
  description:
    'A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be "well-edited" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:23.464Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
